var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAckMobileBgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 478,
    viewBox: "0 0 360 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-24.4994 456.404C-67.4993 399.805 -17.4074 256.597 142.235 256.597C313.001 256.598 425.501 142.968 395.501 8.84188",
    stroke: "#ffecc7",
    strokeWidth: 70
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAckMobileBgImg);
export default __webpack_public_path__ + "static/media/ackMobileBgImg.a87c9a3bd06db5dd1539bc9d48238dde.svg";
export { ForwardRef as ReactComponent };